import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const RWIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="RW" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#FECA00"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#3CA5D9"
          fillRule="evenodd"
          d="M0 0v7h16V0H0Z"
          clipRule="evenodd"
        />
        <Path
          fill="#5A962A"
          fillRule="evenodd"
          d="M0 9v3h16V9H0Z"
          clipRule="evenodd"
        />
        <Path
          fill="#FFDC17"
          d="m12.177 2.009.096.012.414-.94-.057 1.024c.03.01.06.021.089.033l.623-.823-.295.986.08.05.798-.656-.518.89c.023.023.043.047.064.07l.932-.459-.712.751c.016.027.033.053.048.08l1.012-.233-.866.566c.01.03.017.06.025.09l1.041.004-.977.355.004.091 1.014.243-1.036.122c-.005.03-.007.061-.013.091l.928.466-1.036-.117c-.012.029-.025.056-.038.084l.798.666-.983-.35a1.97 1.97 0 0 1-.054.072l.62.83-.874-.565a1.93 1.93 0 0 1-.07.059l.41.95-.718-.749-.083.04.179 1.019-.526-.895-.09.024-.063 1.03-.304-.99c-.016.001-.032.004-.048.004l-.044-.003-.301.989-.064-1.03c-.03-.006-.06-.014-.09-.022l-.524.893.177-1.016c-.028-.013-.057-.026-.084-.04l-.716.746.408-.946a1.96 1.96 0 0 1-.072-.06l-.87.563.616-.826a1.955 1.955 0 0 1-.057-.076l-.975.35.79-.663a1.916 1.916 0 0 1-.038-.087l-1.029.116.921-.463c-.006-.031-.01-.063-.014-.095l-1.028-.121 1.006-.24c.001-.033.001-.065.004-.096l-.969-.353 1.033-.004.028-.093-.862-.563 1.005.231c.016-.028.034-.055.051-.083l-.707-.746.926.456c.022-.024.042-.048.065-.071l-.512-.886.793.655c.027-.019.055-.035.083-.052l-.293-.983.62.82c.03-.012.06-.022.09-.032l-.056-1.023.414.94c.032-.004.063-.01.096-.012L11.994 1l.183 1.009Zm-.204.699c-.7 0-1.268.56-1.268 1.25s.568 1.249 1.268 1.249c.7 0 1.268-.559 1.268-1.249 0-.69-.568-1.25-1.268-1.25Zm.014.572a.714.714 0 1 1 .001 1.43.714.714 0 0 1 0-1.43Z"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
